import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  SelectChangeEvent,
  Chip,
} from "@mui/material";

type LabelValuePairType = {
  label: string;
  value: string;
};

type MultiSelectPropsType = {
  name?: string;
  options?: LabelValuePairType[] | [];
  onChangeCb?: (e: SelectChangeEvent<string[]>) => void;
  value?: string[];
  label?: string;
  size?: "small" | "medium";
  error?: boolean;
  helperText?: string;
  isStarPresent?: boolean;
  disabled?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  renderValue?: (selected: string[]) => React.ReactNode;
  placeholder?: string;
};

const MultiSelect = ({
  name = "",
  label = "",
  value = [],
  options = [],
  isStarPresent = false,
  disabled = false,
  onChangeCb = () => {
    /* no-op */
  },
  size = "small",
  error = false,
  helperText,
  onBlur = () => {},
  renderValue,
  placeholder = "",
}: MultiSelectPropsType) => {
  const defaultRenderValue = (selected: string[]) => {
    if (selected.length > 0) {
      return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {selected.map((value) => {
            const option = options.find((opt) => opt.value === value);
            return (
              <Chip
                key={value}
                label={option?.label || value}
                size="small"
                sx={{
                  backgroundColor: "#E3F2FD",
                  color: "#1976D2",
                  height: "24px",
                  fontSize: "0.75rem",
                  "& .MuiChip-deleteIcon": {
                    color: "#1976D2",
                    fontSize: "16px",
                    "&:hover": {
                      color: "#1565C0",
                    },
                  },
                }}
              />
            );
          })}
        </Box>
      );
    }
    return placeholder || "";
  };

  return (
    <Box sx={{ width: "100%", minWidth: 120 }}>
      <FormControl fullWidth size={size} error={error}>
        <InputLabel id={`${name}-label`}>
          {label} {isStarPresent && <span style={{ color: "#CE0718" }}>*</span>}
        </InputLabel>
        <Select
          labelId={`${name}-label`}
          placeholder={placeholder}
          name={name}
          multiple
          value={value}
          onChange={onChangeCb}
          onBlur={onBlur}
          disabled={disabled}
          renderValue={renderValue || defaultRenderValue}
          label={label}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: error ? "#d32f2f" : "rgba(0, 0, 0, 0.87)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: error ? "#d32f2f" : "#1976d2",
            },
            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: "#1a365d !important",
              color: "white !important",
              "&:hover": {
                backgroundColor: "#2c5282 !important",
                color: "white !important",
              },
            },
            "& .MuiMenuItem-root.Mui-selected.Mui-focusVisible": {
              backgroundColor: "#1a365d !important",
              color: "white !important",
            },
            "& .MuiMenuItem-root.Mui-selected.Mui-focusVisible:hover": {
              backgroundColor: "#2c5282 !important",
              color: "white !important",
            },
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              // sx={{
              //   "&.Mui-selected": {
              //     backgroundColor: "#5c82b5 !important",
              //     color: "white !important",
              //     "&:hover": {
              //       backgroundColor: "#3a5f91 !important",
              //       color: "white !important",
              //     },
              //   },
              //   "&.Mui-selected.Mui-focusVisible": {
              //     backgroundColor: "#1a365d !important",
              //     color: "white !important",
              //   },
              //   "&.Mui-selected.Mui-focusVisible:hover": {
              //     backgroundColor: "#2c5282 !important",
              //     color: "white !important",
              //   },
              // }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default MultiSelect;
